module.exports = __webpack_public_path__ + "static/img/bgc.feac8a6.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/bgc.svg
// module id = gpFX
// module chunks = 1